module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "row"
  }) : _c('div', {
    staticStyle: {
      "margin-top": "-3em"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', [_vm._v("\r\n        Hi Chat " + _vm._s(_vm.set_chat_view) + "\r\n        "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('showProductGrid')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-th"
  })]), _vm._v(" "), (_vm.menu_tab_view.showProductGrid) ? _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      staticClass: "card col-xs-6 card-col-2",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.postChatObject(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em",
        "border-left": "#f5f5f5 solid 0.35em",
        "border-radius": "4px"
      }
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])])])
  })) : _c('div', [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-bottom": "8em"
    }
  }, [(_vm.set_chat_view) ? _c('div', [_vm._l((_vm.chat_log.chats), function(chat) {
    return _c('div', {
      staticClass: "row"
    }, [_c('div', {
      style: (_vm.setChatStyle(chat))
    }, [(chat.chat_from != _vm.chatter.chatter_chat_from) ? _c('p', {
      staticClass: "sp-app-default-color"
    }, [_c('b', [_vm._v(_vm._s(chat.chat_from_name) + "\r\n                      "), (_vm.chatter_set.chatter_style == 2) ? _c('span', [_vm._v("\r\n                        > " + _vm._s(chat.chat_to_name) + "\r\n                      ")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (chat.chat_message_type == 8) ? _c('div', [_c('div', {
      staticClass: "col-xs-6",
      staticStyle: {
        "border-radius": "4px"
      }
    }, [_c('div', {
      staticClass: "card-col-img",
      staticStyle: {
        "margin-bottom": "0.8em"
      }
    }, [(chat.chat_message_object_media) ? _c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": chat.chat_message_object_media
      }
    }) : _c('img', {
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(chat.chat_message_object_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color"
    }, [_vm._v("₦" + _vm._s(chat.chat_message_object_price))]), _c('br'), _vm._v(" "), (chat.chat_message && (chat.chat_message != '')) ? _c('span', {
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v(_vm._s(chat.chat_message))]) : _vm._e()])])])]) : _c('div', [_vm._v("\r\n                    " + _vm._s(chat.chat_message) + "\r\n                  ")]), _vm._v(" "), (_vm.chatter.chatter_style == 2 && (chat.chat_reply_url != '')) ? _c('div', [_c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_c('a', {
      attrs: {
        "href": chat.chat_reply_url
      }
    }, [_vm._v("reply")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "bottom": "5em",
      "position": "fixed"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.postChat
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])])], 2) : _c('div', {
    staticClass: "card"
  }, [(_vm.chat_logs && (Object.keys(_vm.chat_logs).length > 0)) ? _c('div', _vm._l((_vm.chat_logs), function(chatlog) {
    return _c('div', {
      staticClass: "row"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setChatLog(chatlog)
        }
      }
    }, [_c('div', {
      staticClass: "card",
      staticStyle: {
        "border": "gray solid",
        "padding": "0.5em",
        "width": "85%",
        "text-align": "left"
      }
    }, [_vm._v("\r\n                      " + _vm._s(chatlog.chatlog_from_to) + " - " + _vm._s(chatlog.chatlog_from_to_name) + "\r\n                    ")])])])
  })) : _c('div', [_c('p', [_vm._v("No chats yet")])])]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "bottom": "5em",
      "position": "fixed"
    }
  }, [(_vm.chatter.chatter_style == 2) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'You are chatting as ' + _vm.user.user_name,
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chat.chat_set_message),
      expression: "chat.chat_set_message"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.chat.chat_set_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chat.chat_set_message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "sp-button-1",
    staticStyle: {
      "border-radius": "50%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.postChat
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  })])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('u', [_vm._v("Direct Chat Messaging")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a3fa036"}!./src/components/templates/chat/template.html
// module id = 570
// module chunks = 0